
import React from "react"
import { Table, Divider, Space, Button, Pagination, Modal, message } from "antd"

import { AdminService } from "@/services"

import CommonLayout from "@/common/Layout"

class UserIndexPage extends React.PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            userList: [],
            pagination: {
                count: 0,
                pageSize: 20,
                page: 1
            }
        }
    }

    componentDidMount() {
        const page = 1
        this.reloadPaginateUserList(page)
    }

    reloadPaginateUserList(page) {

        const { pagination } = this.state

        const params = {
            page: page,
            page_size: pagination.pageSize
        }

        AdminService.get_user_list(params).then((response) => {
            const { status, body } = response.data
            if (status <= 0) {
                console.error("get_user_list api return status", status)
                return
            }

            this.setState({
                userList: body.users,
                pagination: {
                    page: body.page,
                    pageSize: body.pageSize,
                    count: body.count
                }
            })
        })
    }

    renderUsersTable() {

        const { userList } = this.state

        const columns = [
            {
                title: "用户ID",
                dataIndex: "uid",
                key: "uid",
                align: "center"
            },
            {
                title: '用户昵称',
                dataIndex: 'nickname',
                key: 'nickname',
                align: "center"
            },
            {
                title: '用户名',
                dataIndex: 'username',
                key: 'username',
                align: "center"
            },
            {
                title: '操作',
                key: 'action',
                align: "center",
                render: (text, record) => (
                    <Space>
                        <a onClick={() => console.log("预留1")}>预留1</a>
                        <Divider type="vertical" />
                        <a onClick={() => console.log("预留2")}>预留2</a>
                    </Space>
                )
            },
        ];

        return (
            <Table
                dataSource={userList}
                columns={columns}
                rowKey="uid"
                pagination={false}
            />
        )
    }


    renderPagination() {

        const { page, pageSize, count } = this.state.pagination

        return (
            <Pagination
                current={page}
                pageSize={pageSize}
                total={count}
                hideOnSinglePage={true}
                onChange={(page) => this.reloadPaginateUserList(page)}
            />
        )
    }

    renderPageContent() {
        return (
            <React.Fragment>
                <h2>用户列表</h2>

                <div style={{ marginBottom: 20 }}>
                    {this.renderUsersTable()}
                </div>

                {this.renderPagination()}

            </React.Fragment>
        )
    }

    render() {
        return (
            <CommonLayout selectedMenuKey="user">
                {this.renderPageContent()}
            </CommonLayout>
        )
    }

}

export default UserIndexPage